import { createAction } from '@reduxjs/toolkit';
import { FetchOrganizationBankAccounts, UpdateOrganizationBankAccountVerificationName } from './organization-bank-account.types';

export const FETCH_ORG_BANK_ACCOUNTS_STORE_KEY = 'ORG_BANK_ACCOUNTS/FETCH_ORG_BANK_ACCOUNTS';
export const UPDATE_ORG_BANK_ACCOUNT_VERIFICATION_NAME_STORE_KEY = 'ORG_BANK_ACCOUNTS/UPDATE_VERIFICATION_NAME';
export const UPDATE_ORG_BANK_ACCOUNT_VERIFICATION_NAME_MODAL_STORE_KEY = 'ORG_BANK_ACCOUNTS/UPDATE_VERIFICATION_NAME_MODAL';

export const fetchOrganizationBankAccountsRequested = createAction<FetchOrganizationBankAccounts>(
  `${FETCH_ORG_BANK_ACCOUNTS_STORE_KEY}_API_REQUESTED`,
);
export const fetchOrganizationBankAccountsSuccess = createAction<string[]>(`${FETCH_ORG_BANK_ACCOUNTS_STORE_KEY}_API_SUCCESS`);
export const fetchOrganizationBankAccountsFailed = createAction<string>(`${FETCH_ORG_BANK_ACCOUNTS_STORE_KEY}_API_FAILED`);

export const updateOrganizationBankAccountVerificationNameRequested = createAction<UpdateOrganizationBankAccountVerificationName>(
  `${UPDATE_ORG_BANK_ACCOUNT_VERIFICATION_NAME_STORE_KEY}_API_REQUESTED`,
);
export const updateOrganizationBankAccountVerificationNameSuccess = createAction(
  `${UPDATE_ORG_BANK_ACCOUNT_VERIFICATION_NAME_STORE_KEY}_API_SUCCESS`,
);
export const updateOrganizationBankAccountVerificationNameFailed = createAction<string>(
  `${UPDATE_ORG_BANK_ACCOUNT_VERIFICATION_NAME_STORE_KEY}_API_FAILED`,
);
